import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
// import app from './modules/app'
// import settings from './modules/settings'
import user from './modules/user'
import websocket from "./modules/websocket"
import autoupdateapp from "./modules/autoupdateapp"
// import permission from "./modules/permission"

Vue.use(Vuex)

// //遍历输出modules下的文件
// const modules = modulesFiles.keys().reduce((modules, modulePath) => {
//   // set './app.js' => 'app'
//   const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
//   const value = modulesFiles(modulePath)
//   modules[moduleName] = value.default
//   return modules
// }, {})

const store = new Vuex.Store({
  modules: {
    websocket,
    user,
    autoupdateapp
  },
  state:{
    HCRoutes:[],
    HCNotice:[]
  },
  getters,
  mutations:{
    setNotice(state,params){
        state.HCNotice=params
    }
}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js